import CircularLoader from "./CircularLoader";

export default CircularLoader;
